<template>
    <!--上传下载generic-->
    <div id="importModal">
        <a-modal
                :title="importparams.importTitle"
                :visible="visible"
                width="60%"
                @cancel="cancelModal"
                :maskClosable="maskClosable"
                cancelText="-"
                okText="-"
        >
            <template slot="footer">
                <a-button type="primary" size="small" @click="savePallet">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-row>
                <a-col :span="5">
                    <a-form :form="palletForm" v-if="importparams.palletType == 'palletHeader'">
                        <a-form-item label="ULD#"  v-bind="formItemLayout">
                            <a-input
                                    size="small"
                                    style="width: 250px;"
                                    v-decorator="['ULD', { rules: [{ required: true}] }]"/>
                        </a-form-item>
                    </a-form>
                </a-col>
            </a-row>



            <div>
                <a-row type="flex" justify="space-between" style="margin-bottom: 6px;">
                    <a-col>
                        <a-icon type="search" style="margin-right: 4px;"/>
                        <a-select style="width: 160px" size="small" @change="importTemplateSelectChange" v-model="importTemplateName" :placeholder="$t('publicLang.PleaseSelect')">
                            <a-select-option :value="item" v-for="item in importTemplateSelect">{{ item }}</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col>
                        <a-row type="flex" justify="start">
                            <a-col>
                                <a-pagination
                                        :showTotal="total => `Total ${pagingTotal} Records`"
                                        size="small"
                                        :total="pagingTotal"
                                        v-model="currentVal"
                                        :pageSize.sync="pagingSize"
                                        @change="tableChangePage"
                                        @showSizeChange="onShowSizeChange"
                                        showSizeChanger

                                />
                            </a-col>
                            <a-col>
                                <a-dropdown>
                                    <a class="ant-dropdown-link" href="#">
                                        <img src="../../../assets/img/ss-more.png"  width="15" height="15">
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item style="font-size: 12px" @click="AdvanceSearch">
                                            <a-icon type="zoom-in" /> {{ $t('pubGicSet.AdvanceSearch') }}
                                        </a-menu-item>
                                        <a-menu-item style="font-size: 12px" @click="searchSort">
                                            <a-icon type="ordered-list" /> {{ $t('pubGicSet.AdvanceSort') }}
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <vxe-table
                        v-if="isInTable"
                        stripe
                        border
                        highlight-hover-row
                        resizable
                        :data.sync="dataImportTbale.data"
                        size="mini"
                        max-height="350"
                        :loading="parloading"
                        @header-cell-dblclick="headerCellDbclick"
                        ref="importTableRefs"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                    <template v-for="(item, index) in dataImportTbale.columns">
                        <vxe-table-column
                                show-header-overflow
                                show-overflow
                                :key="index"
                                :width="item.proWidth == null ? '200' : item.proWidth">
                            <template v-slot:header="{ column }">
                                <span>{{ item.title }}</span>
                                <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                                    <input
                                            type="text"
                                            :placeholder="$t('publicLang.PleaseEnter')"
                                            style="width: 50%;border-right: none;"
                                            v-model="item.serVal"
                                            @keyup.enter="searchTitleCont"/>
                                    <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                      <a-icon type="search"  @click="searchTitleCont"/>
                  </span>
                                    <span style="display: inline-block;">
                      <a-icon type="caret-up" class="sortBtnClass" @click="locaSort(1, item)"/>
                      <a-icon type="caret-down" class="sortBtnClass" @click="locaSort(-1, item)"/>
                    </span>
                                </div>
                            </template>
                            <template v-slot="{ row }">
                                <div>
                <span style="fontSize: 12px;height: 30px;line-height: 30px;display: block;">{{row[item.label].value == null ? "-" : row[item.label].value}}</span>
                                </div>
                            </template>
                        </vxe-table-column>
                    </template>
                </vxe-table>
            </div>
        </a-modal>

        <!--Advance search-->
        <a-modal
                :title="$t('pubGicSet.AdvanceSearch')"
                v-model="AdvanceSearchVis"
                width="80%">
            <template slot="footer">
                <a-button type="primary"size="small" @click="getQueryFilter" >{{ $t('pubGicSet.Search') }}</a-button>
            </template>
            <a-row>
                <a-col :span="18">
                    <a-row type="flex" justify="start">
                        <a-col style="margin-right: 5px;">
                            <span>{{ $t('pubGicSet.SearchTemplate') }}: </span>
                        </a-col>
                        <a-col>
                            <a-select
                                    size="small"
                                    style="width: 240px"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-model="targetAdvanceTml"
                                    @change="changeTamplateAdvace"
                            >
                                <a-select-option :value="item" v-for="item in AdvanceTemplate">{{ item }}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col class="mllr4">
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('roleGe.Add') }}</span>
                                </template>
                                <img @click="showAddTemplatName" class='sbxs' src="../../../assets/img/ss-add.png" width="20" height="20">
                            </a-tooltip>
                        </a-col>
                        <a-col>
                            <a-popconfirm
                                    :title="$t('pubGicSet.AreyoudeleTask')"
                                    :okText="$t('pubGicSet.Yes')"
                                    :cancelText="$t('pubGicSet.No')"
                                    @confirm="deleteTemplatName">
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>{{ $t('pubGicSet.delete') }}</span>
                                    </template>
                                    <img class='sbxs' src="../../../assets/img/ss-delete.png" width="20" height="20">
                                </a-tooltip>
                            </a-popconfirm>
                        </a-col>
                        <a-col class="mllr4">
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('publicLang.Save') }}</span>
                                </template>
                                <img  @click="saveTemplateVers" class='sbxs' src="../../../assets/img/ss-save.png" width="20" height="20">
                            </a-tooltip>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row>
                <import-or :options="options" :isFirst="isFirst" ref="andOrImport"></import-or>
            </a-row>
        </a-modal>
        <!--添加Advance search temalate name-->
        <a-modal :title="$t('roleGe.Add')" v-model="AdchNameVis">
            <template slot="footer">
                <a-button size="small" type="primary" @click="SaveTamplateName">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="AdchNameFrom">
                <a-form-item :label="$t('pubGicSet.Name')" v-bind="formItemLayout">
                    <a-input
                            v-decorator="[
              'template',
              { rules: [{ required: true, message: $t('publicLang.Required') }] }
             ]"
                            :placeholder="$t('publicLang.PleaseEnter')"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
        <!--排序-->
        <a-modal :title="$t('pubGicSet.Sort')" v-model="searchSortVis" width="50%">
            <template slot="footer">
                <a-button type="primary" @click="getUpdateEvent" size="small">{{ $t('pubGicSet.Search') }}</a-button>
            </template>
            <div style="height: 55vh;">
                <vxe-table
                        border
                        class="sortable-row-demo"
                        row-key
                        size="mini"
                        ref="addPalletSortTable"
                        :data.sync="editTableData"
                        height="auto"
                        :edit-config="{ key: 'detaileUid', trigger: 'click', mode: 'row' }">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                    <vxe-table-column field="fieldName" :title="$t('generic.FieldName')"></vxe-table-column>
                    <vxe-table-column
                            field="orderBy"
                            :title="$t('generic.OrderBy')"
                            width="140"
                            :edit-render="{ type: 'visible' }">
                        <template v-slot:edit="{ row, rowIndex }">
                            <a-switch
                                    v-model="row.orderBy"
                                    checkedChildren="asc"
                                    unCheckedChildren="desc"
                                    size="small"
                            ></a-switch>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </a-modal>

    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import tableComs from "../../com/tableComs.vue";
    import functionBar from "../components/functionBar.vue";
    import editFrom from "../components/editFrom.vue";
    import importOr from '../../com/queryBuilder/components/AndOR.vue'
    import Sortable from "sortablejs";
    import axios from "axios";
    import cookie from "../../../api/cookie";
    import moveCom from '../custPage/move.vue'
    export default {
        components: {
            tableComs,
            functionBar,
            editFrom,
            importOr,
            moveCom,
        },
        props: {
            visible: {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            importparams: {
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        watch: {
            importparams(val) {
                this.initData();
            }
        },
        data() {
            return {
                palletForm: this.$form.createForm(this),
                iFexcelFileBtn: true,
                upErrorInfo:false, // 上转报错弹窗
                upErrordata: [], // 报错信息
                upErrordataStr: '', // 没过滤报错信息
                updataExcelName: '', // 上传成功文件名
                searchSortVis: false, // 是否去排序
                editTableData: [], // 排序表格数据

                importTemplateName: undefined, // 本地上传表格 module code 选中的值
                importTemplateSelect: [],// 本地上传表格 module code 下拉数据
                AdvanceSearchVis: false, // 是否打开advansearch
                targetAdvanceTml: [],
                isFirst: true,
                options: {},
                AdchNameVis: false,
                AdvanceTemplate: [],
                importAdvanuserSqlDto: {},
                AdchNameFrom: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },

                excenModuleCode: undefined,// module value
                excelSelectData: [], // 上转excel module 下拉数据
                eddvisible: false,
                QueryUpdatas: "",
                apiType: "",
                parloading: false, // 表格加载
                pagingTotal: 0, // 总条数
                currentVal: 1, // 当前页数
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 显示条数
                dataImportTbale: {}, // table 数据
                dataImport: {}, // 请求import 数据
                maskClosable: false, // 关闭遮罩
                isInTable: false,
                importTypeLookup: '',
                importUserSortDtos: [],
                genericMasterModuleCode: null,

                importSearchTitle: [],
                importSortKey: '',
                importSortType: '',
                isHeaderSearchFlag: false
            };
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        methods: {
//            保存pallet
            savePallet(){
                this.palletForm.validateFields((err,values)=>{
                    if(!err){
                        let params = {}
                        let uids = []
                        let ajaxName =''
                        let updateRecords = this.$refs.importTableRefs.getCheckboxRecords()
                        if (updateRecords.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                            return;
                        }
                        for(let i in updateRecords){
                            uids.push(updateRecords[i].uid)
                        }
                        if(this.importparams.palletType=='palletHeader'){
                            params = {
                                palletNo: values.ULD,
                                cfsOrderDetailUids: uids
                            }
                            ajaxName = api.CFSADDPALLET
                        }else if(this.importparams.palletType == 'palletDetail'){
                            params={
                                cfsOrderDetailUids: uids,
                                cfsPalletHeaderUid: this.importparams.targetUID
                            }
                            ajaxName = api.CFSADDPALLETDETAIL
                        }else if(this.importparams.palletType == 'shipmentDetail'){
                            params = {
                                orderDtailUids: uids,
                                shipmentUid: this.importparams.targetUID
                            }
                            ajaxName = api.CFSUPDATEORDERDETAIL
                            // console.info(this.importparams)
                        }
                        ajax.post(ajaxName,params).then(res=>{
                            if(res.code == 200){
                                this.$emit("cancelImport", "init");
                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },

//      表头search
            headerCellDbclick(){
                this.isHeaderSearchFlag = !this.isHeaderSearchFlag
            },
            searchTitleCont(){
                let scParams = [];
                let columns = this.dataImportTbale.columns
                columns.forEach((v, i) => {
                    if (v.serVal) {
                        scParams.push({ key: v.uid, value: v.serVal });
                    }
                });
                this.importTypeLookup = 'tel'
                this.importSearchTitle = scParams
                this.initData()
            },
            compare(propertyName) {
                return (object1, object2) => {
                    let a =
                        object1[propertyName].value == null
                            ? "9"
                            : object1[propertyName].value;
                    let b =
                        object2[propertyName].value == null
                            ? "9"
                            : object2[propertyName].value;
                    if (a < b) {
                        return this.importSortType * 1;
                    } else if (a > b) {
                        return this.importSortType * -1;
                    }
                    return 0;
                };
            },
            dataTest() {
                let that = this;
                let tableData = this.dataImportTbale.data;
                let sortKey = this.importSortKey;
                if (sortKey) {
                    this.dataImportTbale.data = tableData.sort(that.compare(sortKey));
                }
                this.dataImportTbale.data = tableData
                this.$forceUpdate()
            },
            locaSort(type, item) {
                this.importSortKey = item.label;
                this.importSortType = type;
                this.dataTest()
            },
//      表头search

            rowDrop() {
                this.$nextTick(() => {
                    let sortTable = this.$refs.addPalletSortTable
                    let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        onEnd: ({ newIndex, oldIndex }) => {
                            let currRow = this.editTableData.splice(oldIndex, 1)[0];
                            this.editTableData.splice(newIndex, 0, currRow);
                        }
                    });
                });
            },
            searchSort(){

                this.$message.success("Drag the list to sort");
                let gmcUid =  this.dataImport.gmcUid
                this.searchSortVis = true;
                ajax.get(api.SEARCHSORT, { gmcUid: gmcUid }).then(res => {
                    this.editTableData = res.data;
                    let checkboArr = [];
                    this.editTableData.forEach((v, i) => {
                        v.orderBy = v.orderBy == 0 ? false : true;
                        if (v.isSort == "1") {
                            checkboArr.push(this.editTableData[i]);
                        }
                        this.$refs.addPalletSortTable.setCheckboxRow(checkboArr, true);
                    });
                    this.rowDrop();
                })
            },
            getUpdateEvent(){
                let updateRecords = this.$refs.addPalletSortTable.getCheckboxRecords();
                for (let ii in updateRecords) {
                    updateRecords[ii].isSort = "1";
                }
                this.importTypeLookup = 'sort'
                this.importUserSortDtos = updateRecords
                this.initData()
                this.currentVal = 1
                this.searchSortVis = false
            },

            importTemplateSelectChange(val){
                this.targetAdvanceTml = val
                this.currentVal = 1
                this.importAdvanuserSqlDto = {gmcUid: this.dataImport.gmcUid, template: this.targetAdvanceTml}
                this.importTypeLookup = 'advan'
                this.initData()
            },
            AdvanceSearch(){
                this.AdvanceSearchVis = true
                let uid =  this.dataImport.gmcUid
                ajax.get(api.ADVANCETEMPLATE, { gmcUid: uid }).then(res => {
                    this.AdvanceTemplate = res.data;
                    this.targetAdvanceTml = this.AdvanceTemplate[0];
                });
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });
                let params = {
                    gmcUid: uid
                };
                ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                    this.options.fieldNameSel = res.data;
                    let queryParams = {
                        gmcUid: uid
                    };
                    ajax.get(api.QUERYFILTER, queryParams).then(res => {
                        let queryObj = res.data;
                        this.$refs.andOrImport.fillFormStatus(queryObj);
                    });
                });
            },
            changeTamplateAdvace(val){
                let params = {
                    gmcUid: this.dataImport.gmcUid,
                    template: val
                };
                ajax.get(api.QUERYFILTER, params).then(res => {
                    let queryObj = res.data;
                    this.$refs.andOrImport.fillFormStatus(queryObj);
                });
            },
            showAddTemplatName(){
                this.AdchNameVis = true
            },
            deleteTemplatName(val){
                let params = {
                    gmcUid: this.dataImport.gmcUid,
                    templateName: this.targetAdvanceTml
                };
                ajax.post(api.DELETETEMPLATE, params).then(res => {
                    if (res.code == 200) {
                        this.AdvanceSearch();
                    }
                });
            },
            saveTemplateVers(){
                if(this.targetAdvanceTml != ''){
                    let params = this.$refs.andOrImport.queryFormStatus();
                    params.template = this.targetAdvanceTml
                    params.gmcUid = this.dataImport.gmcUid,
                        ajax.post(api.QUERYFILTER, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success('Save Success')
                            }
                        })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseFirst'));
                }
            },
            SaveTamplateName(){
                this.AdchNameFrom.validateFields((error, values) => {
                    if (!error) {
                        let params = this.$refs.andOrImport.queryFormStatus();
                        params.template = values.template;
                        params.gmcUid = this.dataImport.gmcUid
                        ajax.post(api.QUERYFILTER, params).then(res => {
                            if (res.code == 200) {
                                this.AdvanceSearch();
                                this.AdchNameVis = false;
                            }
                        });
                    }
                });
            },
            getQueryFilter(){
                this.importAdvanuserSqlDto = this.$refs.andOrImport.queryFormStatus()
                this.AdvanceSearchVis = false;
                this.importTypeLookup = 'advan'
                this.currentVal = 1
                this.initData();
            },


            //      上转excel
            fileChange(el) {
                let params = {}
                params.geMapMasterUid =  this.excenModuleCode;
                params.moduleCode = this.genericMasterModuleCode
                let file = event.target.files[0]; // 获取上传excel
                this.updataExcelName = file.name
                this.upErrordata = []
                ajax.post(api.GENERICIMPORTMODULEDATA, params, "chardimportExcelImport", file).then(res => {
                    this.$refs.importExcelRef.value = ''
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.updataExcelName = ''
//                        上传成功后返回字符串 父表请求要带上
                        if(typeof (res.data) == 'string'){
                            let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                            let topMenuActive = sessionStorage.getItem("menuActive")
                            for(let i in topMenu){
                                if(topMenu[i].key == topMenuActive){
                                    topMenu[i].importUids = res.data
                                }
                            }
                            sessionStorage.setItem("menu", JSON.stringify(topMenu));
                            this.$emit("cancelImport", "init");
                        }else{
                            this.$emit("cancelImport", "init");
                        }
//                         上传成功之后 返回数组去move
                        if(res.data.length == 1){
                            if(this.importparams.isMove == 'Move'){
                                let paramsData = [];
                                let paramsObj = {}
                                paramsObj.key = "uid";
                                paramsObj.value = res.data[0]
                                paramsData.push(paramsObj)
                                let edit = {
                                    params: paramsData,
                                }
                                this.$refs.moveComs.show('Move',edit)
                            }
                        }else{
                            this.$emit("cancelImport", "init");
                        }
                    } else {
//                        某些时候上传失败也会返回字符串 父表请求要带上
                        if(typeof (res.data) == 'string'){
                            let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                            let topMenuActive = sessionStorage.getItem("menuActive")
                            for(let i in topMenu){
                                if(topMenu[i].key == topMenuActive){
                                    topMenu[i].importUids = res.data
                                }
                            }
                            sessionStorage.setItem("menu", JSON.stringify(topMenu));
                            this.$emit("cancelImport", "init");
                        }
                        this.upErrordataStr = res.msg
                        if (this.upErrordataStr.indexOf('@excelFileName') > 0){
                            this.iFexcelFileBtn = true
                        }else{
                            this.iFexcelFileBtn = false
                        }
                        let data = res.msg
                        if(data.split('@')){
                            data = data.split('@')[0]
                        }
                        data = data.split('//')
                        data = Array.from(new Set(data))
                        this.upErrordata = data
                        this.upErrorInfo = true
                    }
                });
            },

            //      分页事件start
            tableChangePage(current) {
                this.currentVal = current;
                this.initData();
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.initData();
            },
            //      分页事件end
            //            获取弹窗表格数据
            initData() {
                this.dataImportTbale = {};
                this.excenModuleCode = undefined
                this.pagingTotal = 0
                this.parloading = true
                this.isInTable = false
                if (this.importparams.importType == "excel") {
                    this.parloading = false;
                    ajax.get(api.GENERICCURRENTSUBMODULECODE,{gmcUid:this.importparams.gmcUid}).then(res=>{
                        let moduleCode = res.data
                        this.genericMasterModuleCode = res.data
                        ajax.get(api.GENERICGEMAPMASTER,{moduleCode: moduleCode}).then(res=>{
                            this.excelSelectData = res.data.geMapMasterList
                            if(this.excelSelectData.length == 1){
                                this.excenModuleCode =   this.excelSelectData[0].uid
                            }
                        })
                    })
                    return false;
                }
                let params = {
                    gmcUid: this.importparams.gmcUid,
                    language: this.importparams.language,
                    functionUid: this.$route.query.funcUid,
                    userUid: this.$route.query.userUid,
                    paging: {
                        pageNum: this.currentVal,
                        pageSize: this.pagingSize
                    }
                };
                if(this.importTypeLookup == 'sort'){
                    params.userSortDtos = this.importUserSortDtos
                }else if(this.importTypeLookup == 'advan'){
                    params.userSqlDto = this.importAdvanuserSqlDto
                }else if(  this.importTypeLookup == 'tel'){
                    params.columnSearch = this.importSearchTitle
                }
                ajax.post(api.SKUS, params).then(res => {
                    this.parloading = false;
                    this.isInTable = true
                    if (res.code == 200) {
                        this.importTypeLookup = ''
                        this.dataImport = res.data;
                        if(res.data.tableList.paging != null){
                            this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        }
                        this.dataImportTbale = res.data.tableList;
                        ajax.get(api.ADVANCETEMPLATE, { gmcUid: this.dataImport.gmcUid }).then(res => {
                            this.importTemplateSelect = res.data
                            if(this.importTemplateSelect.length> 0){
                                this.importTemplateName = this.importTemplateSelect[0]
                            }
                        });
                    } else {
                        this.$customMessage.warning(res.msg, 5);
                    }
                });
            },
            // save import
            handleToolClick(val) {
                if (val.code == "BTN_SAVE") {
                    if (val.type == "BUTTON" && val.patternType == "EXT") {
                        let paramsData = [];
                        let updateRecords = this.$refs.importTableRefs.getCheckboxRecords()
                        let patterParams = val.pattern.params;
                        if(patterParams == null){
                            this.$customMessage.warning(this.$t('publicLang.Wrongconfiguration'), 3);
                            return;
                        }
                        if (patterParams.length > 0) {
                            if (updateRecords.length < 1) {
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                                return;
                            }
                            let SaveData = updateRecords
                            for (let index in SaveData) {
                                if (SaveData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = SaveData[index].uid;
                                    paramsData.push(paramsObj);
                                }
                            }
                        }else{
                            this.$customMessage.warning(this.$t('publicLang.Wrongconfiguration'), 5);
                            return
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            functionUid: this.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            language: this.importparams.language,
                            headerUid: this.importparams.targetUID

                        };
                        ajax.post(val.externalApi, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.$emit("cancelImport", "init");
                            } else {
                                this.$customMessage.warning(res.msg);
                            }
                        });
                    }
                    if (val.type == "BUTTON" && val.patternType == "INT") {
                        this.saveImport();
                    }
                }
            },
            //      import 编辑弹窗返回值
            GETcancelModalVisible(val) {
                this.eddvisible = false;
                this.$emit("cancelImport", "init");
            },

            saveImport() {
                let updateRecords = this.$refs.importTableRefs.getCheckboxRecords()
                if (updateRecords.length  != 1) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                } else {
                    let paramsPopup = {
                        gmcUid: this.importparams.partTableUid,
                        importForView: {
                            dataUid: updateRecords[0].uid,
                            gmcUid: this.importparams.gmcUid,
                            mapUid: this.importparams.fieldMapUid
                        },
                        language: this.importparams.language
                    };
                    this.eddvisible = true;
                    ajax.post(api.POPUP, paramsPopup).then(res => {
                        this.QueryUpdatas = res;
                        (this.QueryUpdatas.behrUid = this.importparams.btnUid),
                            (this.QueryUpdatas.fieldMapUid = this.importparams.fieldMapUid);
                        (this.QueryUpdatas.partTableUid = this.importparams.partTableUid),
                            (this.QueryUpdatas.uid = updateRecords[0].uid);
                        this.QueryUpdatas.type = "import";
                        this.apiType = "edit";
                    });
                }
            },
            //            弹窗取消
            cancelModal() {
                if(this.excenModuleCode){
                    if(this.importparams.importType == 'excel'){
                        document.getElementById('uploadEventFile').value = ''
                    }
                }
                this.$emit("cancelImport", "close");
            },
        }
    };
</script>
<style lang="less">
    .example {
        text-align: center;
        border-radius: 4px;
        padding: 80px 50px;
        margin: 20px 0;
    }
</style>
